export default __webpack_public_path__ + "static/media/CNo.47-4.9fe462fa.jpg";